import React, { useEffect, useRef, useState } from "react";
import Banner from "./Banner";
import { useApi } from "../lib/useApi";

const Banners = () => {
  const { data: BannerArray = [] } = useApi(`/api/GetBanners`, { select: (json) => json.value });
  const [ImageLoaded, setImageLoaded] = useState(false);
  const [ImageIndex, setImageIndex] = useState(0);
  // The rotation runs from mount, before the banners arrive, so it reads the count from here.
  const bannerCount = useRef(0);
  useEffect(() => {
    bannerCount.current = BannerArray.length;
  });

  const confirmLoaded = () => {
    setImageLoaded(true);
  };

  useEffect(() => {
    let pointer = 0;

    const goToNext = () => {
      const isLastBanner = pointer === bannerCount.current - 1;
      const newIndex = isLastBanner ? 0 : pointer + 1;
      pointer = isLastBanner ? 0 : pointer + 1;
      setImageIndex(newIndex);
    };

    const intervalId = setInterval(() => {
      if (bannerCount.current > 1) {
        goToNext();
      }
    }, 5000);
    return () => clearInterval(intervalId);
  }, []);

  return (
    <div className="row second">
      <div className="large-12 columns" style={{ paddingLeft: "0.3em" }}>
        {ImageLoaded ? null : (
          <div
            style={{
              background: "#c0cdd8",
              height: "139px",
              width: "794px",
              // On phones a full-width placeholder widens the page while the banner loads,
              // and Foundation then lays out the pool tabs for desktop (issue #35).
              maxWidth: "100%",
            }}
          />
        )}
        {BannerArray.map((item, index) => (
          <Banner key={item.name} index={index} imageIndex={ImageIndex} item={item} imageLoaded={ImageLoaded} confirmLoaded={confirmLoaded} />
        ))}
        <a
          href="https://www.tab.co.za/tabs/featured"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src="https://4rsoccer6us.blob.core.windows.net/sportco-4racing-soccer6-blobs/tab_casino.png"
            alt="TAB casino"
            style={{ display: "inline", marginTop: "4px" }}
          />
        </a>
      </div>
    </div>
  );
};

export default Banners;
